import React from "react";
import { connect } from "react-redux";
import AddRuleInputField from "./RuleNameField";
import DescriptionField from "./DescriptionField";
import SeverityDropdown from "./SeverityDropdown";
import ShareWithCommunityField from "./ShareWithCommunityField";
import EnableSystemRemediationField from "./EnableSystemRemediationField";
import { canEditRuleFields } from "../rulePermissions";

function RuleTab({ rule, auth }) {
    const disabled = rule.baseRule === true || !canEditRuleFields(auth);

    return (
        <>
            {/* Checkboxes row */}
            <div className="addrules-checkbox-row-v2">
                <EnableSystemRemediationField value={rule.enableRemediation}
                    ruleKey={'enableRemediation'}
                    disabled={disabled} />
                <ShareWithCommunityField disabled={disabled} />
            </div>

            <AddRuleInputField label={'Name'} ruleKey={'name'}
                disabled={disabled} />
            <AddRuleInputField label={'Version'} ruleKey={'version'}
                disabled={disabled} />
            <AddRuleInputField label={'Section'} ruleKey={'sectionName'}
                disabled={disabled}
                placeholder={'-'} />
            <AddRuleInputField label={'Subsection'} ruleKey={'subsectionName'}
                disabled={disabled}
                placeholder={'-'} />
            <SeverityDropdown disabled={disabled} />
            <DescriptionField disabled={disabled} />
        </>
    )

}

function mapStateToProps(state) {
    const addRulesPage = state.addRulesPage;
    const auth = state.auth;
    return {
        rule: addRulesPage.rule,
        auth,
    }
}

export default connect(mapStateToProps)(RuleTab);
